import React, { memo } from 'react';
import { MfeReactComponent } from '@carvana/microfrontend-react';

export const LeadCapture = memo(() => {
  return <MfeReactComponent module="LeadCaptureModule" component="default" />;
});
